// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"556":"SweftWorkspace","741":"AdminWorkspace","874":"SuperAdminWorkspace"}[chunkId] || chunkId) + "." + {"358":"d5f5ddcb46da2485be16","471":"22a2f2a9e844d2eaf58d","556":"919be11d40aa664cf2ec","741":"5f1b6e3dd1a07d2f08f5","874":"6dde2b5607978372dbce"}[chunkId] + ".css";
};